import React, { useState } from 'react';

import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from 'react-bootstrap/Modal';
import Plantilla from './plantillas/Plantilla';

//import error from '../img/negativo.svg';

import { SignOutButton } from '../components/office365auth/SignOutButton';

export const ContinuarMasTardeButton = () => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [performSignOut, setPerformSignOut] = useState(false);
    const handleOkClick = () => {
        setShowConfirmModal(false);
        setPerformSignOut(true);
    };

    return (<>
        <Row className="mb-3">
            <Col className="d-grid gap-2">
                <Button variant="link" onClick={() => { setShowConfirmModal(true); }}>Continuar el proceso más tarde</Button>
            </Col>

            {performSignOut && <SignOutButton performSignOut={performSignOut} />}
        </Row>

        <ConfirmModal
            show={showConfirmModal}
            okCaption="Continuar con inscripción"
            onOkClick={() => { setShowConfirmModal(false) }}
            cancelCaption="Entiendo, continuaré después"
            onCancelClick={() => { handleOkClick() }}
        >
            
            <Plantilla id="ConfirmarContinuarProcesoMasTarde" />
        </ConfirmModal>
    </>);
};


const ConfirmModal = ({ show, children, okCaption, onOkClick, cancelCaption, onCancelClick }) => {
    return (<>
        <Modal show={show} centered style={{ maxHeight: "100%" }}>
            <Modal.Body>
                <div className="container portal">
                    {children}

                    <Row className="mb-3 mt-4">
                        <Col className="d-grid gap-2">
                            <Button variant="primary" onClick={onOkClick}>
                                {okCaption}
                            </Button>
                        </Col>
                    </Row>
                    <Row className=" mt-4">
                        <Col className="d-grid gap-2">
                            <Button variant="primary bg-color-red" onClick={onCancelClick}>
                                {cancelCaption}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    </>);
};

